import react, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCardMembers } from '../../redux/Slices/cardMemberSlice';

import MembersPopover from './MembersPopover';

import MemberImage from '../Global/MemberImage';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';
import { fetchWorkspaces } from '../../redux/Slices/workspaceSlice';
import { find } from '../../utils/helpers';
import { fetchMembers } from '../../redux/Slices/memberSlice';
import Add from '../icons/Add';



const CardMembers = ({ cardId, isReadOnly }) => {

    const dispatch = useDispatch();

    const { handlePopoverClick } = useHandlePopoverClick();
    const { cardMembers } = useSelector(state => state.member) || [];

    useEffect(() => {
        dispatch(fetchMembers({ type: 'card', id: cardId }));
    }, [cardId, dispatch]);


    return (
        <>
            {
                cardMembers?.length > 0 && (

                    <div className="zoobbe-card-members">
                        <h5>Members</h5>
                        <div className='member-list'>

                            <div className="avatars">
                                <MemberImage cardId={cardId} members={cardMembers} type={'card'} size={35} isReadOnly={isReadOnly} />
                            </div>
                            {
                                !isReadOnly && (
                                    <div className='add-member-to-card' id='popover-add-member-to-card' onClick={(e) => handlePopoverClick(e, 'cardMemberesPopover')} data-popover-trigger>
                                        <Add size={22} color='var(--primary-text-color)' />
                                    </div>
                                )
                            }

                        </div>
                    </div>
                )
            }
        </>
    )
}


export default CardMembers;